export const quranNl = {
  landing: {
    badge: 'De Koran is nu voor iedereen toegankelijk',
    titleLine1: 'De Koran, voor iedereen.',
    titleGradient: 'Lees. Luister. Bestudeer.',
    subtitle:
      'De hele Koran in het Arabisch, met vertalingen in het Nederlands, Duits, Frans, Engels en Bosnisch. Gratis, zonder aanmelden, op elk apparaat. Zoek een woord, tel het in de hele Koran en luister vers voor vers.',
    appNote: 'Voor hifz met AI, offline audio en gebedstijden: download de app.',
    daily: 'Vers van de dag',
    listen: 'Luisteren',
    study: 'Bestudeer dit vers',
    studyEyebrow: 'De Koran op Deenly',
    studyTitle: 'Lees niet alleen. Bestudeer.',
    studySubtitle: 'Hulpmiddelen die je helpen begrijpen wat je leest, gratis voor iedereen.',
    cards: [
      { to: '/quran/', icon: 'solar:book-2-linear', title: 'Lezen en luisteren', body: 'Alle 114 soera’s, de Arabische tekst met vertalingen en zes recitatoren. De speler volgt het vers dat wordt gereciteerd, zelfs vanaf je vergrendelscherm.', cta: 'Open de Koran' },
      { to: '/quran/tafsir/', icon: 'solar:notebook-bookmark-linear', title: 'Tafsir van elk vers', body: 'Wat betekent een vers? Uitleg in het Nederlands bij bijna elk vers (NÛR, op basis van Ibn Kathîr en as-Sa’dî), en Al-Mukhtasar in het Engels, Frans, Bosnisch en het Arabische origineel, met bron en citaat.', cta: 'Open de tafsir' },
      { to: '/quran/search/', icon: 'solar:magnifer-linear', title: 'Zoek op woord of betekenis', body: 'Vind een vers op een woord, de naam van een soera of een verwijzing als 2:255. Of beschrijf een thema en AI vindt verzen op betekenis.', cta: 'Doorzoek de Koran' },
      { to: '/quran/2/255/', icon: 'solar:square-academic-cap-linear', title: 'Woord voor woord', body: 'Tik op een Arabisch woord: je ziet de wortel, de grammatica en hoe vaak het in de Koran voorkomt. Volg vanuit de wortel één gedachte door de hele Koran.', cta: 'Probeer het op Ayat al-Kursi' },
    ],
  },
  nav: {
    home: 'Deenly-startpagina',
    quran: 'Koran',
    label: 'Korannavigatie',
    read: 'Lezen',
    search: 'Zoeken',
    words: 'De Koran in cijfers',
    tafsir: 'Tafsir',
    roots: 'Wortels',
    chronology: 'Chronologie',
    switchLanguage: 'Taal wijzigen',
  },
  common: {
    close: 'Sluiten',
    error: 'Er ging iets mis. Probeer het zo meteen opnieuw.',
    notFound: 'Dit vers bestaat niet.',
    breadcrumbs: 'Kruimelpad',
    pagination: 'Vorige en volgende',
    loadMore: 'Meer laden',
  },
  translation: {
    de: 'Duits · Bubenheim & Elyas',
    nl: 'Nederlands · Rowwad Translation Center',
    fr: 'Frans · Rachid Maach',
    bs: 'Bosnisch · Besim Korkut',
    en: 'Engels · Saheeh International',
  },
  quick: {
    label: 'Meest gelezen',
    ayatulKursi: 'Ayat al-Kursi',
    lastOfBaqarah: 'Einde van Al-Baqarah',
  },
  index: {
    badge: 'Voor iedereen · gratis · zonder aanmelden',
    title: 'De Koran, voor iedereen',
    subtitle:
      'Alle 114 soera’s in het Arabisch, met vertalingen in het Nederlands, Duits, Frans, Engels en Bosnisch. Luister vers voor vers, zoek op woord of betekenis en bestudeer elk woord.',
    stats: [
      { label: 'Soera’s', value: '114' },
      { label: 'Verzen', value: '6.236' },
      { label: 'Talen', value: '6' },
      { label: 'Recitatoren', value: '6' },
    ],
    wordsTitle: 'Hoe vaak zegt de Koran…?',
    wordsBody:
      'Typ een woord (in het Nederlands, Arabisch, Engels of Bosnisch) en zie binnen een seconde hoe vaak het voorkomt, in welke soera’s en verzen. Vergelijk twee woorden en bekijk de Koran vanuit een nieuwe hoek.',
    wordsCta: 'Open De Koran in cijfers',
    surahsTitle: 'Alle soera’s',
    surahsSubtitle: 'Vind er een op naam, betekenis of nummer.',
    filterLabel: 'Soera’s filteren',
    filterPlaceholder: 'bijv. Yasin, Al-Kahf, 18…',
    filterRevelation: 'Plaats van openbaring',
    filterAll: 'Alle',
    noMatch: 'Geen enkele soera komt overeen.',
  },
  surah: {
    meccan: 'Mekkaans',
    medinan: 'Medinisch',
    ayahCount: '{n} vers | {n} verzen',
    juz: 'Juz {n}',
    listen: 'Luister naar de soera',
    previous: 'Vorige soera',
    next: 'Volgende soera',
  },
  ayah: {
    actions: 'Acties voor {ref}',
    listen: 'Luister naar {ref}',
    copy: 'Vers kopiëren',
    save: 'Bewaren in mijn studeerkamer',
    saved: 'Bewaard in je collectie',
    copied: 'Gekopieerd',
    share: 'Delen',
    study: 'Bestudeer {ref}',
    sajdah: 'Sajdah',
  },
  ayahPage: {
    eyebrow: 'Vers',
    inContext: 'Lees in context',
    listenOn: 'Luister vanaf hier',
    previous: 'Vorig vers',
    next: 'Volgend vers',
    wordsTitle: 'Woord voor woord',
    wordsHint: 'Elk woord van het vers met uitspraak en betekenis. Tik op een woord om te zien hoe vaak het in de Koran voorkomt.',
    wordsSource: 'Uitspraak en woordbetekenissen: Quran.com.',
    wordsSourceBs: 'Uitspraak en woordbetekenissen: Quran.com.',
    relatedTitle: 'Verwante verzen',
    relatedHint: 'Verzen elders in de Koran die over hetzelfde thema gaan.',
    aboutSurah: 'Over deze soera',
  },
  settings: {
    title: 'Instellingen',
    translation: 'Vertaling',
    both: 'Beide',
    none: 'Geen',
    arabicFont: 'Arabisch schrift',
    arabicSize: 'Grootte Arabische tekst',
    sizeStep: 'Grootte {n}',
    wordStudy: 'Woordstudie',
    wordStudyHint: 'Tik op een Arabisch woord om te zien hoe vaak het in de Koran voorkomt.',
  },
  player: {
    label: 'Koranspeler',
    play: 'Afspelen',
    pause: 'Pauzeren',
    previous: 'Vorig vers',
    next: 'Volgend vers',
    stop: 'Stoppen en sluiten',
    expand: 'Speler openen',
    collapse: 'Speler minimaliseren',
    nowPlaying: 'Nu gereciteerd',
    openSurah: 'Soera openen',
    seek: 'Positie in het vers',
    failed: 'De audio is niet geladen. Controleer je verbinding en probeer het opnieuw.',
    reciter: 'Recitator',
    repeatAll: 'Alles herhalen',
    ayahRepeat: 'Elk vers herhalen: {n}',
    repeatRound: 'keer {n}',
    volume: 'Volume',
    sleep: 'Slaaptimer',
    sleepMinutes: 'Over {n} minuten',
    sleepEnd: 'Aan het einde van de soera',
    sleepOff: 'Timer uitzetten',
    tabText: 'Tekst',
    ayahOf: 'vers {ayah} van {total}',
    backToCurrent: 'Terug naar het gereciteerde vers',
    speed: 'Snelheid',
    follow: 'De recitatie volgen',
    followHint: 'Terwijl een soera speelt, scrolt de pagina vanzelf naar het vers dat wordt gereciteerd en markeert het.',
  },
  peek: {
    title: 'Het woord {word} in de Koran',
    eyebrow: 'Dit woord in de Koran',
    exact: 'Precies deze vorm',
    inside: 'Binnen andere woorden',
    spread: 'In {ayahs} verzen, verspreid over {surahs} soera’s.',
    open: 'Alle vermeldingen',
  },
  tafsir: {
    nav: 'Tafsir',
    cta: 'Open de tafsir',
    teaser: 'Wat betekent een vers? Uitleg in het Nederlands bij bijna elk vers (NÛR, op basis van Ibn Kathîr, as-Sa’dî en Ibn al-Qayyim), en Al-Mukhtasar in het Engels, Frans, Bosnisch en het Arabische origineel, met bron en citaat voor je studie.',
    eyebrow: 'De Koran uitgelegd',
    title: 'Tafsir van de Koran',
    intro:
      'Uitleg in het Nederlands bij 6.217 van de 6.236 verzen, van NÛR: een hedendaagse hervertelling op basis van Ibn Kathîr, as-Sa’dî en Ibn al-Qayyim, per groep verzen. Daarnaast Al-Mukhtasar bij elk vers, in het Engels, Frans, Bosnisch en het oorspronkelijke Arabisch. Lees de tafsir soera voor soera, vergelijk hem met het origineel en zoek op wat er over een thema wordt gezegd.',
    facts: { ayahs: 'verzen uitgelegd', langs: 'talen: Nederlands, Engels, Frans, Bosnisch, Arabisch', surahs: 'soera’s' },
    surahsTitle: 'Tafsir per soera',
    surahsHint: 'Kies een soera: elk vers in het Arabisch, met de vertaling en daaronder de uitleg.',
    aboutTitle: 'Over Al-Mukhtasar',
    about: [
      'Al-Mukhtasar in Interpreting the Noble Quran is samengesteld door het Tafsir Center for Quranic Studies. Elk vers wordt kort en helder uitgelegd, zonder lange uitweidingen. Dat past zowel bij dagelijks lezen als bij serieuze studie.',
      'Het werk is in het Arabisch geschreven; de Engelse, Franse en Bosnische teksten zijn vertalingen van dat origineel. Daarom kun je bij elk vers het Arabische origineel openen en met de vertaling vergelijken.',
    ],
    methodTitle: 'Hoe het hier wordt gepubliceerd',
    method: [
      'De tekst wordt precies zo gepubliceerd als de bron hem uitgeeft, zonder wijzigingen of inkortingen.',
      'Bij elke tekst staan de titel, de auteur, de editie en de datum van ophalen, en de knop “Citeren” geeft een kant-en-klaar citaat met link.',
      'De tafsir wordt gelijk gehouden met de nieuwste versie die QuranEnc.com publiceert.',
    ],
    langLabel: 'Taal van de tafsir',
    langs: { bs: 'Bosanski', en: 'English', fr: 'Français', nl: 'Nederlands', ar: 'العربية' },
    sameAs: 'Zie de uitleg bij vers {n}.',
    retold: 'Een hedendaagse hervertelling op basis van de klassieke geleerden, geen letterlijke vertaling',
    translationOf: 'Vertaald uit het Arabische origineel',
    original: 'Arabisch origineel',
    label: 'Tafsir',
    ayahTitle: 'Tafsir van dit vers',
    ayahHint: 'Wat dit vers betekent: de uitleg van NÛR of uit Al-Mukhtasar.',
    wholeSurah: 'Tafsir van de hele soera',
    readSurah: 'Lees de soera',
    show: 'Tafsir',
    hide: 'Tafsir verbergen',
    toggle: 'Tafsir van {ref}',
    inReader: 'Tafsir onder elk vers',
    inReaderHint: 'Een korte uitleg onder elk vers. Met de knop “Tafsir” bij een vers open je die per vers.',
    showAyah: 'Vers en vertaling',
    ayahIndex: 'Verzen',
    goToAyah: 'Ga naar vers {n}',
    source: 'Bron',
    sourceLine: '{title} — {author}. {publisher}, editie “{edition}”, opgehaald op {date}.',
    cite: 'Citeren',
    cited: 'Citaat gekopieerd',
    refAyah: 'van vers {key}',
    refSurah: 'van soera {name}',
    citation: '{title} ({author}), uitleg {ref}. {publisher}, editie “{edition}”, opgehaald op {date}. {url}',
    unavailable: 'Bij dit vers is de tafsir in deze taal niet beschikbaar. Je kunt hem lezen in het Engels, Frans, Bosnisch of Arabisch.',
    searchTitle: 'Doorzoek de tafsir',
    searchLabel: 'Doorzoek de tafsir',
    searchPlaceholder: 'Een thema of woord in de taal van de tafsir, bijv. patience, parents, Day of Judgement',
    searchHint: 'Doorzoekt de uitleg, niet alleen de verzen: vind wat de tafsir over een thema zegt. Zoek in de gekozen taal van de tafsir.',
    resultCount: 'Geen enkel vers heeft “{q}” in de tafsir | {n} vers heeft “{q}” in de tafsir | {n} verzen hebben “{q}” in de tafsir',
    previous: 'Vorige soera',
    next: 'Volgende soera',
  },
  opinions: {
    title: "Wat de geleerden zeiden",
    searchHint: "Antwoorden van geleerden van Ahl as-Sunnah, gevonden op woorden en op betekenis, elk met een link naar de bron.",
    ayahHint: "Antwoorden die deze aya aanhalen.",
    none: "Geen antwoord gevonden.",
    scholars: "Geleerden",
    citedAyat: "Aangehaalde ayat:",
    source: "Lees bij de bron: {source}",
    inLanguage: "Beschikbaar in: {language}",
  },
  search: {
    title: 'Doorzoek de Koran',
    label: 'Doorzoek de Koran',
    placeholder: 'Een woord, soera of vers (bijv. mercy, Yasin, 2:255)',
    submit: 'Zoeken',
    suggestions: 'Suggesties',
    jump: 'Ga naar vers {ref}',
    allResults: 'Alle resultaten voor “{q}”',
    countWord: 'Hoe vaak wordt “{q}” genoemd?',
    modeLabel: 'Zoekmethode',
    byWords: 'Op woorden',
    byMeaning: 'Op betekenis',
    byScholars: "Geleerden",
    byTafsir: 'In de tafsir',
    meaningHint: 'Beschrijf een thema in je eigen woorden, bijv. “verzen over geduld in moeilijke tijden”. AI vindt verzen op betekenis, niet op trefwoord.',
    meaningTooShort: 'Typ minstens drie letters.',
    meaningError: 'Zoeken op betekenis is nu niet beschikbaar. Probeer te zoeken op woorden.',
    resultCount: 'Geen verzen voor “{q}” | {n} vers voor “{q}” | {n} verzen voor “{q}”',
    took: '{ms} ms',
    aiLabel: 'Kunstmatige intelligentie',
    aiWorking: 'AI doorzoekt de Koran op betekenis…',
    aiFound: 'AI heeft geen vers gevonden voor deze vraag | AI heeft {n} vers gevonden op betekenis | AI heeft {n} verzen gevonden op betekenis',
    emptyTitle: 'Waarop je kunt zoeken',
    tips: [
      'Een woord in het Nederlands, Engels, Bosnisch of Arabisch: genade, mercy, milost, رحمة',
      'De naam van een soera: Kahf, Yasin, Rahman',
      'Een exact vers: 2:255 of 36 1',
      'Een thema op betekenis: kies “Op betekenis”',
    ],
  },
  words: {
    title: 'De Koran in cijfers',
    subtitle:
      'Hoe vaak komt een woord in de Koran voor, in welke soera’s, Mekkaans of Medinisch? Typ een woord of vergelijk er twee, met één klik.',
    tryOne: 'Probeer een voorbeeld:',
    examples: 'Voorbeelden',
    inputLabel: 'Woord om te tellen',
    placeholder: 'Een woord (bijv. mercy, الله, milost)',
    compareLabel: 'Woord om te vergelijken',
    comparePlaceholder: 'Een tweede woord om te vergelijken',
    wordA: 'Eerste woord',
    wordB: 'Tweede woord',
    addCompare: 'Vergelijken met een ander woord',
    removeCompare: 'Vergelijking verwijderen',
    count: 'Tellen',
    langLabel: 'Taal van de tekst',
    langBs: 'Bosnisch',
    langEn: 'Engels',
    arabicDetected: 'Geteld in de Arabische tekst',
    modeLabel: 'Hoe een woord overeenkomt',
    modeWord: 'Heel woord',
    modePrefix: 'Begint met',
    modeContains: 'Bevat',
    modeHint: {
      word: 'Telt precies dat woord: “day” telt “days” niet mee.',
      prefix: 'Telt elk woord dat ermee begint: “merc” telt mercy, merciful, mercies…',
      contains: 'Telt woorden waarin het voorkomt: het Arabische “الله” telt ook “والله”, “بالله”…',
    },
    occurrences: '{n} keer | {n} keer',
    inAyahs: 'in {ayahs} verzen, {surahs} soera’s',
    revelationSplit: 'Mekkaanse soera’s {meccan}%, Medinische {medinan}%',
    firstSeen: 'Eerste',
    lastSeen: 'Laatste',
    topSurahs: 'Het vaakst in',
    equal: '“{a}” en “{b}” worden even vaak genoemd, elk {n} keer.',
    nearlyEqual: '“{a}” en “{b}” worden bijna even vaak genoemd: {x} en {y} keer.',
    ratio: '“{more}” wordt {ratio}× zo vaak genoemd als “{less}”.',
    chartTitle: 'Over de 114 soera’s',
    chartHint: 'Eén kolom per soera, in de volgorde van de mushaf. Klik op een kolom voor details.',
    chartLabel: 'Aantal keren per soera',
    chartCaption: 'Kolomdiagram: één kolom voor elk van de 114 soera’s; de hoogte is het aantal keren dat het woord voorkomt.',
    openSurah: 'Soera openen',
    noneTitle: 'Geen resultaten',
    noneBody: 'Vertalingen geven dezelfde gedachte vaak met andere woorden weer. Probeer “Begint met” of “Bevat”, een synoniem of het Arabische woord, want de Arabische tekst is leidend.',
    ayahsTitle: 'Verzen',
    method:
      'We tellen woordvormen in de tekst, zonder klinkertekens. De Arabische tekst is leidend; vertalingen gebruiken verschillende woorden voor dezelfde gedachte, dus hun aantallen wijken af van het Arabisch.',
  },
  grammar: {
    title: 'Grammatica',
    root: 'Wortel',
    lemma: 'Woordenboekvorm',
    parts: 'Delen van het woord',
    noRoot: 'Partikels en voornaamwoorden hebben geen wortel.',
    rootCount: '{n}× in de Koran',
    allOfRoot: 'Alle woorden van deze wortel',
    person: '{n}e persoon',
    gender: { M: 'mannelijk', F: 'vrouwelijk' },
    number: { S: 'enkelvoud', D: 'tweevoud', P: 'meervoud' },
    form: 'werkwoordsvorm {n}',
    passive: 'passief',
    definite: 'bepaald (met ٱل)',
    indefinite: 'onbepaald',
    family: 'uit de familie van “{word}”',
    tense: { PERF: 'perfectum (verleden tijd)', IMPF: 'imperfectum (tegenwoordige/toekomende tijd)', IMPV: 'gebiedende wijs' },
    case: { NOM: 'nominatief', ACC: 'accusatief', GEN: 'genitief' },
    mood: { IND: 'indicatief', SUBJ: 'subjunctief', JUS: 'jussief' },
    class: {
      V: 'werkwoord',
      N: 'zelfstandig naamwoord',
      PN: 'eigennaam',
      ADJ: 'bijvoeglijk naamwoord',
      ACT_PCPL: 'actief deelwoord',
      PASS_PCPL: 'passief deelwoord',
      VN: 'verbaal naamwoord (masdar)',
      PRON: 'voornaamwoord',
      DEM: 'aanwijzend voornaamwoord',
      REL: 'betrekkelijk voornaamwoord',
      T: 'bijwoord van tijd',
      LOC: 'bijwoord van plaats',
      NV: 'werkwoordelijk tussenwerpsel',
      P: 'partikel',
    },
    particle: {
      DET: 'bepaald lidwoord',
      CONJ: 'voegwoord',
      REM: 'hervattingspartikel',
      P: 'voorzetsel',
      NEG: 'ontkenningspartikel',
      EMPH: 'nadrukspartikel',
      INTG: 'vraagpartikel',
      VOC: 'vocatiefpartikel',
      FUT: 'toekomstpartikel',
      CERT: 'partikel van zekerheid',
      RSLT: 'gevolgpartikel',
      CAUS: 'partikel van oorzaak',
      SUB: 'onderschikkend voegwoord',
      COND: 'voorwaardelijk partikel',
      RES: 'beperkingspartikel',
      PRP: 'partikel van doel',
      CIRC: 'omstandigheidspartikel',
      EXP: 'uitzonderingspartikel',
      PREV: 'verhinderingspartikel',
      PRO: 'verbodspartikel',
      RET: 'terugtrekkingspartikel',
      SUP: 'aanvullend partikel',
      SUR: 'verrassingspartikel',
      EXH: 'aansporingspartikel',
      EXL: 'verklaringspartikel',
      EQ: 'gelijkstellingspartikel',
      AMD: 'correctiepartikel',
      ANS: 'antwoordpartikel',
      AVR: 'afwerendpartikel',
      COM: 'partikel van begeleiding',
      INC: 'beginpartikel',
      INT: 'partikel van interpretatie',
      INL: 'Koranische beginletters',
      ATT: 'aandachtspartikel',
      DIST: 'afstandsaanduiding',
      ADDR: 'aanduiding van de aangesprokene',
      ACC: 'accusatiefpartikel',
    },
  },
  roots: {
    nav: 'Wortels',
    eyebrow: 'De woordenschat van de Koran',
    title: 'De wortels van Koranische woorden',
    subtitle:
      'Bijna elk Arabisch woord groeit uit een wortel van drie of vier letters: de wortel صبر geeft geduld, geduldig en geduld hebben. Kies een wortel en volg één gedachte door de hele Koran.',
    factRoots: 'wortels',
    factLemmas: 'woordenboekvormen',
    factWords: 'woorden met hun grammatica',
    lettersLabel: 'Wortels op beginletter',
    searchLabel: 'Doorzoek de wortels',
    searchPlaceholder: 'Een wortel of betekenis (bijv. رحم, knowledge, mercy)',
    count: '{n} wortels',
    showing: '{shown} van {total} getoond',
    none: 'Geen enkele wortel past bij je zoekopdracht.',
    showMore: 'Meer tonen',
    sortLabel: 'Sorteren',
    sortFrequent: 'Meest voorkomend',
    sortAlpha: 'Alfabetisch',
    occurrences: '{n}× in de Koran',
    words: '{n} woord | {n} woorden',
    pageTitle: 'De wortel {root}',
    pageSubtitle: 'Elk woord dat uit deze wortel is opgebouwd, waar het in de Koran voorkomt en elk vers waarin het staat.',
    lemmasTitle: 'Woorden uit deze wortel',
    lemmasHint: 'Klik op een woord om alleen de verzen daarvan te zien.',
    allLemmas: 'Alle woorden',
    lemmaCol: 'Woord',
    classCol: 'Soort',
    meaningCol: 'Betekenis',
    countCol: 'Aantal',
    filtered: 'Alleen getoond: {lemma}',
    clearFilter: 'Toon de hele wortel',
    chartTitle: 'Over de 114 soera’s',
    ayahsTitle: 'Verzen',
    back: 'Alle wortels',
    notFound: 'Deze wortel komt niet voor in de Koran.',
    whatTitle: 'Wat is een wortel?',
    whatBody:
      'In het Arabisch zit de betekenis in de wortel, meestal drie medeklinkers, en klinkers en toevoegingen bouwen daar woorden omheen. De wortel كتب geeft kataba (hij schreef), kitāb (boek), kātib (schrijver) en maktūb (geschreven). Wie een wortel volgt, ziet hoe de Koran één gedachte ontvouwt in veel woorden.',
    methodTitle: 'Bron en methode',
    methodBody:
      'De wortel, de woordenboekvorm en de grammatica van elk woord komen uit het Quranic Arabic Corpus (University of Leeds), waarin elk van de 77.429 woorden met de hand is geannoteerd. De betekenissen van wortels en woorden zijn door AI samengevat uit de woord-voor-woordbetekenis in elk vers; zie ze als richtlijn, niet als woordenboek.',
    source: 'Grammatica: Quranic Arabic Corpus 0.4, Kais Dukes, University of Leeds (GNU GPL), met correcties uit mustafa0x/quran-morphology.',
    aiNote: 'Betekenissen samengevat door AI',
    teaser: 'Bijna elk Arabisch woord groeit uit een wortel van drie letters. Volg een wortel door de hele Koran: elk woord dat eruit is opgebouwd, wat het betekent en elk vers.',
    cta: 'Ontdek de wortels',
  },
  translations: {
    eyebrow: 'Meer vertalingen',
    title: 'Vertalingen naast elkaar',
    hint: 'Hetzelfde vers in meerdere vertalingen. Kies er een als basis om te zien waar de andere het anders vertalen.',
    compareWith: 'Markeer de verschillen met',
    compareOff: 'Geen vergelijking',
    isBase: 'basis van de vergelijking',
    alike: '{n}% dezelfde woorden',
    legendAdded: 'anders',
    legendRemoved: 'weggelaten',
    legendNote: 'Vertalingen in dezelfde taal worden woord voor woord vergeleken.',
    footnote: 'Voetnoot {n}',
    notes: 'Noten van de vertaler ({n})',
    extra: 'Meer vertalingen onder elk vers',
    extraHint: 'Naast Korkut en Saheeh International, via QuranEnc.com.',
    lang: { bs: 'Bosanski', en: 'English', de: 'Deutsch', nl: 'Nederlands', fr: 'Français' },
    names: {
      'bubenheim': 'Bubenheim & Elyas (Duits)',
      'rowwad-de': 'Rowwad (Duits)',
      'rowwad-nl': 'Rowwad (Nederlands)',
      rashid: 'Rachid Maach (Frans)',
      'noor-fr': 'Noor International (Frans)',
      korkut: 'Besim Korkut',
      mehanovic: 'Muhamed Mehanović',
      'rowwad-bs': 'Rowwad (Bosnisch)',
      saheeh: 'Saheeh International',
      'hilali-khan': 'Hilali & Khan',
      'rowwad-en': 'Rowwad (Engels)',
    },
  },
  chronology: {
    nav: 'Chronologie',
    eyebrow: 'Volgorde van openbaring',
    title: 'De Koran in de volgorde van openbaring',
    subtitle:
      'De Koran is geleidelijk geopenbaard, in ongeveer 23 jaar, en de mushaf zet de soera’s niet in die volgorde. Hier staan ze zoals ze zijn neergedaald: van de eerste verzen van Al-Alaq in Mekka tot de laatste soera’s in Medina.',
    factYears: 'jaar van openbaring',
    factMeccan: 'Mekkaanse soera’s',
    factMedinan: 'Medinische soera’s',
    timelineTitle: 'Elke soera in de volgorde van openbaring',
    timelineHint: 'Elke kolom is één soera, zo hoog als ze lang is in woorden. Klik op een kolom om de soera te openen.',
    timelineInsight:
      'De eerste soera’s die werden geopenbaard, zijn kort, ritmisch en krachtig. Naarmate de openbaring vordert, worden ze langer, en na de Hidjra naar Medina komen de langste soera’s, met de wetten van een gemeenschap.',
    barHint: 'Hoogte = aantal woorden',
    hijra: 'Hidjra (622)',
    revealedNth: 'als {n}e geopenbaard',
    ayahs: 'Verzen',
    words: 'Woorden',
    ayahCount: '{n} verzen',
    chartLabel: 'Staafdiagram: de 114 soera’s in de volgorde van openbaring; de hoogte is het aantal woorden, de kleur de Mekkaanse of Medinische periode.',
    chartCaption: 'Soera’s van links naar rechts in de volgorde van openbaring; de stippellijn is de Hidjra.',
    compareTitle: 'Mekkaanse en Medinische soera’s',
    compareSubtitle: 'Eén Koran, twee perioden: dertien jaar mensen oproepen in Mekka en tien jaar een gemeenschap opbouwen in Medina. Het verschil is ook in de cijfers te zien.',
    metric: {
      surahs: 'Soera’s',
      ayahs: 'Verzen',
      words: 'Woorden',
      wordsPerAyah: 'Woorden per vers (gemiddeld)',
      ayahsPerSurah: 'Verzen per soera (gemiddeld)',
    },
    lengthInsight: 'Een Mekkaans vers telt gemiddeld {meccan} woorden, een Medinisch {medinan}. De korte, krachtige verzen van Mekka worden in Medina langer en gedetailleerder, omdat ze wetten brengen.',
    distinctive: {
      meccan: 'Kenmerkend voor de Mekkaanse soera’s',
      medinan: 'Kenmerkend voor de Medinische soera’s',
    },
    distinctiveHint: 'Wortels die de ene periode veel vaker gebruikt dan de andere. Cijfers: Mekkaans · Medinisch.',
    methodNote:
      'Methode: de log-oddsratio met een informatieve Dirichlet-prior (Monroe, Colaresi & Quinn, 2008), als z-score. Die meet niet hoe gewoon een woord is, maar hoe onverwacht vaak het in één periode voorkomt, en is voorzichtig met zeldzame woorden. Wortels uit het Quranic Arabic Corpus.',
    listTitle: 'De soera’s in de volgorde van openbaring',
    period: { meccan: 'Mekkaanse periode · 1–86', medinan: 'Medinische periode · 87–114' },
    aboutTitle: 'Over de volgorde van openbaring',
    about1:
      'Dit is de volgorde van de gangbare Egyptische uitgave van de mushaf (al-Azhar, 1924), die steunt op overleveringen van de metgezellen en hun leerlingen. Het is de meest geciteerde volgorde, maar niet de enige: geleerden verschillen van mening over de plaats van sommige soera’s, en sommige soera’s bevatten verzen uit beide perioden.',
    about2:
      'Soera’s die vóór de Hidjra zijn geopenbaard, gelden als Mekkaans en die erna als Medinisch, waar een vers ook is geopenbaard. De jaartallen zijn bij benadering: de openbaring begon rond 610, de Hidjra was in 622 en de laatste verzen kwamen in 632.',
    source: 'Bronnen: volgorde van openbaring en de Mekkaanse/Medinische indeling, Tanzil Project (tanzil.net, CC BY 3.0); woorden en wortels, Quranic Arabic Corpus 0.4 (corpus.quran.com).',
    teaser: 'De soera’s in de volgorde van openbaring op een tijdlijn, en hoe de Mekkaanse en Medinische soera’s verschillen: in lengte, in ritme en in woorden.',
    cta: 'Open de chronologie',
    mushafOrder: 'Volgorde van de mushaf',
    revelationOrder: 'Volgorde van openbaring',
    orderLabel: 'Volgorde van de soera’s',
  },
  app: {
    available: 'Gratis in de',
    eyebrow: 'De Deenly-app',
    title: 'Neem de Koran met je mee',
    subtitle:
      'Op het web lees en bestudeer je. In de app leeft de Koran met je mee: leer uit je hoofd met AI die naar je recitatie luistert, luister offline en raak nooit meer je plek kwijt.',
    features: [
      { icon: 'solar:microphone-3-linear', title: 'Hifz AI', body: 'Reciteer hardop en elk woord wordt als goed of fout gemarkeerd.' },
      { icon: 'solar:download-minimalistic-linear', title: 'Offline audio', body: 'Download soera’s en luister overal.' },
      { icon: 'solar:bell-linear', title: 'Herinneringen', body: 'Een zacht duwtje in de ochtend en de avond, met een vers van de dag.' },
      { icon: 'solar:cup-star-linear', title: 'Khatm en onderscheidingen', body: 'Een leesplan en mijlpalen die je gaande houden.' },
    ],
  },
  footer: {
    title: 'De Koran op Deenly',
    body: 'De Koran is voor iedereen toegankelijk, gratis en zonder account. De tekst en de vertalingen komen uit de betrouwbare bronnen hieronder.',
    arabic: 'Arabische tekst',
    audio: 'Audio',
    bs: 'Bosnische vertaling',
    en: 'Engelse vertaling',
    links: 'Links',
  },
};
